import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  authStoreAuthedSelector,
  authStoreCheckedSelector,
  authStoreCheckingSelector,
  authStoreUserSelector,
  authStoreUserTournamentId,
  selectHasTournaments,
} from '../../store/selectors';

export const useAuth = () => {
  const isAuthed = useSelector(authStoreAuthedSelector);
  const isChecking = useSelector(authStoreCheckingSelector);
  const isChecked = useSelector(authStoreCheckedSelector);
  const user = useSelector(authStoreUserSelector);
  const userTournamentId = useSelector(authStoreUserTournamentId);
  const hasTournaments = useSelector(selectHasTournaments);

  return useMemo(
    () => ({
      isAuthed,
      isChecking,
      isChecked,
      userTournamentId,
      user,
      hasTournaments,
    }),
    [isAuthed, isChecking, isChecked, userTournamentId, user, hasTournaments],
  );
};
